import { HttpUpcomingEvents } from "../Http";
export class UpEventAPI {
 public static getupevent(input: any) {


    var obj = JSON.stringify(input);

    var url = "/upcomingeventsimmigrationnews/createUpcomingEventsImmigrationNews";


 
    const resultMethod = HttpUpcomingEvents.axios()
      .post(url, obj, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      }) 
      .then(res => {
        return res;

      })

      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;


  }
  public static getcomingupevent(input: any) {



    var url = "/upcomingeventsimmigrationnews/getAllUpcomingEventsImmigrationNews";



    const resultMethod = HttpUpcomingEvents.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {

        return res;

      })

      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;


  }

  public static updateupcomingevent(input: any) {

 

    var obj = JSON.stringify(input);
    if (input === "") {
      return { data: [] };
    }
    var url = "/upcomingeventsimmigrationnews/updateUpcomingEventsImmigrationNews";
    const resultMethod = HttpUpcomingEvents.axios().put(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }
}